import Container from 'react-bootstrap/Container'
import {Button, Card, Modal} from 'react-bootstrap'
import TableAsignatedResponsable from './TableAssignatedResponsable'
import Common from '../componentCaseHistory'
import React, { useEffect, useState, Fragment } from 'react'
import { connect } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ModalBitacora from '../../containers/modalBitacora'
import {getCases, getFormLabel, getCasesImplicated, getFormLabelByForm, cleanStateAssignated } from '../../store/actions'
import {CarpetaDigitalComponent} from 'reccol-caso-general'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { CasoGeneralComponent } from 'reccol-caso-general'

const AsignatedResponsable = ({
  data,
  onGetGestionCases,
  onGetFormLabel,
  onGetGestionCasesImplicated,
  onGetFormLabelByForm,
  onCleanState,
  form
}) => {
  const [loading] = useState(false)

  const { state } = useLocation()

  const { rutUsuario } = Auth.currentUser()
  // ---Parametros
  const idOrgano = state?.row?.idOrgBien ? state.row.idOrgBien : '8600399880'
  const idCaso = state?.row?.IdCaso ? state.row.IdCaso : '6'
  const areaTrabajo = state?.formValues ? state.formValues : {}
  const idImplicado = state?.row?.IdImplicado ? state.row.IdCaso : 0

  const user = rutUsuario

  const history = useNavigate()

  const [showBitacora, setShowBitacora] = useState(false)
  const handleCloseBitacora = () => setShowBitacora(false)

  const [showCarpeta, setShowCarpeta] = useState(false)
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta= () => setShowCarpeta(false)

  useEffect(() => {
    onGetGestionCases({
      idOrgCaso: idOrgano,
      idCaso: idCaso
    })
    onGetFormLabel()
    onGetFormLabelByForm({
      rutcia: idOrgano,
      idform: 4
    })
    onGetGestionCasesImplicated({
      idOrgCaso: idOrgano,
      idCaso: idCaso
    })
  }, [])

  const options = {
    data: data?.cases[0],
    form: form,
    dataImplicated: data?.implicated,
    idCaso,
    idOrgano,
    idImplicado
  }

  const optionsAsignatedResposable = {
    dataCases: data?.cases[0],
    form: form?.formLabeByForm,
    idCaso,
    idOrgano,
    user,
    areaTrabajo
  }


  const queryState=JSON.parse(localStorage.getItem('filtrosAreaGestion'))
  const onBack = () => {
    onCleanState()
    history('/area-gestion-compania', {
      state: {queryState}
    })
  }

  const onBitacora = () => {
    setShowBitacora(true);
  }

  return (

    <>
    <style type='text/css'>
      {`
      .btn-bitacora {
        background-color: #55B2CE;
        color: #FFFFFF;
        width: 140px;
      }
      .btn-bitacora:hover{
          background-color: #87c9dc;
          color: #FFFFFF;
      }
      .btn-asignar {
        background-color: #C14B49;
        color: #FFFFFF;
        width: 100px;

      }
      .btn-asignar:hover{
          background-color: #d3807f;
        color: #FFFFFF;
      }
      .btn-confirmar {
        background-color: #C14B49;
        color: #FFFFFF;
        width: 140px;

      }
      .btn-confirmar:hover{
          background-color: #d3807f;
        color: #FFFFFF;
      }
      .btn-volver {
        color: #66CCCC;
        border: 1px solid #C00
        width: 140px;
      }
      .btn-tamano{
        padding: 1rem 1.5rem;
        font-size: 1.5rem;
      }
      .btn-carpeta {
        background-color: #D59B49;
        color: #FFFFFF;
        width: 140px;
        
      }
      .btn-carpeta:hover{
          background-color:#e1b97f;
          color: #FFFFFF;
  
      }
      `}
    </style>
    <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">              
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={idCaso}
          idImplicado={idImplicado}
          idOrganizacionCaso={idOrgano}
          prototipo={2}            
          />     
    </Modal>
    <Container className='mt-2'>
      <LoadingComponent show={loading || data.loading || form.loading} />
      {data?.cases.length > 0 &&
      Object.keys(form?.formLabel).length > 0 &&
      Object.keys(form?.formLabeByForm).length > 0 ? (
        <Card className='mt-2'>
          {/*<Common {...options} />*/}
          <Card className='mt-2'>
            <Card.Header className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
              {form?.formLabeByForm['asigcaso-title-page']} {idCaso}
            </Card.Header>
            <Card.Body>
              <CasoGeneralComponent idCaso={idCaso} idImplicado={idImplicado} idOrganizacionCaso={idOrgano} />
            </Card.Body>
          </Card>  
          <Card className='mt-2'>
          <Card.Header className='m-2 border border-2' style={{backgroundColor: '#4F517A', color: 'white'}}>
            {form?.formLabeByForm['asigcaso-title-selresponsable']}
          </Card.Header>

          <Card.Body className='m-2 border border-2'>
            <TableAsignatedResponsable
              className='m-2'
              {...optionsAsignatedResposable}
            />

            <div
              className='d-grid gap-2 d-md-block  mt-4 mb-2'
              style={{
                float: 'Right'
              }}
            >
              <Button
                className='m-2 w-auto'
                variant='outline-info'
                onClick={() => onBack()}
              >
                {form?.formLabeByForm['asigcaso-btn-volver']}
              </Button>
              <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta}> 
                    {form?.formLabeByForm['asigcaso-btn-cd']}
                  </Button>
              <Button
                type='button'
                onClick={() => onBitacora()}
                variant='bitacora'
              >
                {form?.formLabeByForm['asigcaso-btn-bitacora']}
              </Button>
            </div>
          </Card.Body>
          {showBitacora && (
              <ModalBitacora
                show={showBitacora}
                handleClose={handleCloseBitacora}
                idCaso={idCaso}
                rutcia={idOrgano}
                user
              />
            )}
          </Card>
        </Card>
      ) : null}
    </Container>
    </>
  )
}

const mapStateToProps = (state) => ({
  data: state.cases,
  form: state.formLabel
})

const mapDispatchToProps = (dispatch) => ({
  onGetGestionCases: (query) => dispatch(getCases(query)),
  onGetGestionCasesImplicated: (query) => dispatch(getCasesImplicated(query)),
  onGetFormLabel: () => dispatch(getFormLabel()),
  onGetFormLabelByForm: (query) => dispatch(getFormLabelByForm(query)),
  onCleanState: () => dispatch(cleanStateAssignated())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AsignatedResponsable)
